import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Vuelidate from "vuelidate";
import VueCroppie from "vue-croppie";
import "croppie/croppie.css";
import apiServices from "../services/apiServices";
import "@/assets/css/modularCSS.css";
import "@/assets/css/all.css";
import jwtDecode from "jwt-decode";

Vue.use(Vuelidate);
Vue.use(VueCroppie);
const eventBus = new Vue();
export default eventBus;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  created() {
    const isMob = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
    if (isMob) {
      router.push("/");
    }

    const userToken = localStorage.getItem("token");
    const platform = localStorage.getItem("platform");
    apiServices.customizeHeader(userToken);
    apiServices.interceptionRoute();
    if (userToken) {
      const decode = jwtDecode(userToken);
      this.$store.commit("SET_CREDENTIALS", userToken);
      this.$store.commit("SET_DATA_PLATFORM", platform);
      this.$store.commit("SET_DATA_USER", decode);
      if (localStorage.getItem("Mopt") === "xYzH") {
        this.$store.commit("SET_MENU_OPT", false);
      }
      if (localStorage.getItem("Mopt") === "xYzN") {
        this.$store.commit("SET_MENU_OPT", true);
      }
    }
  },
  render: h => h(App)
}).$mount("#app");
